import SpinnerIcon from '@components/icons/spinner-icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Image from '../../elements/image/image';

import styles from './google-pay-button.module.scss';

const GooglePayButton: React.FC<{
  readonly onClick: React.MouseEventHandler<HTMLButtonElement>;
  readonly loading?: boolean;
}> = ({ onClick, loading = false }) => {
  const { t } = useTranslation();

  return (
    <button type="button" className={styles.button} onClick={onClick}>
      {loading ? (
        <SpinnerIcon />
      ) : (
        <>
          <span>{t('payment.google_pay_label')}</span>
          <Image
            src="/google-pay.svg"
            alt="Google Pay"
            width="52"
            height="21"
          />
        </>
      )}
    </button>
  );
};

export default GooglePayButton;
